<template>
  <div class="consultant-profile-wrapper">
    <div class="__head" :class="{ __onscoll_header: isScoll }">
      <div class="personal_data" :style="{
        'background-image': $hasKey(profile_data, 'profile.cover_photo')
          ? 'url(' +
          $fullUrl('images/covers/' + profile_data.profile.cover_photo) +
          ')'
          : false,
      }">
        <div class="person-card">
          <img v-if="profile_data.user.profile_picture" :src="$fullUrl('images/profiles/' + profile_data.user.profile_picture)
            " />
          <img v-else src="@/assets/avatar.png" alt />
          <div class="info-text">
            <h2>
              {{ profile_data.user.first_name | validate }}
              {{ profile_data.user.last_name | validate }}
            </h2>
            <span v-if="$hasKey(profile_data, 'profile.location.country.name') &&
              $hasKey(profile_data, 'profile.location.city.name')
              ">{{ profile_data.profile.location.country.name | validate }},
              {{ profile_data.profile.location.city.name | validate }}</span>
          </div>
        </div>
      </div>
      <!-- Tab section -->
      <div class="tabs-widget">
        <div class="tabs-links">
          <div class="tab" style="justify-content: flex-start" :class="{ active: tab_type == 'public-information' }"
            @click="switchTab('public-information')">
            <span class="name">Public information</span>
            <span class="icon">
              <img v-if="tab_type == 'public-information'"
                src="@/assets/icons/consultant-profile-icons/general-infos-active.svg" />
              <img v-else src="@/assets/icons/consultant-profile-icons/general-infos.svg" />
            </span>
          </div>
          <div class="tab" :class="{ active: tab_type == 'project' }" @click="switchTab('project')">
            <span class="name">Projects</span>
            <span class="icon">
              <img v-if="tab_type == 'project'" src="@/assets/icons/consultant-profile-icons/projects-active.svg" />
              <img v-else src="@/assets/icons/consultant-profile-icons/projects.svg" />
            </span>
          </div>
          <div class="tab" :class="{ active: tab_type == 'skills' }" @click="switchTab('skills')">
            <span class="name">Skills</span>
            <span class="icon">
              <img v-if="tab_type == 'skills'" src="@/assets/icons/consultant-profile-icons/skills-active.svg" />
              <img v-else src="@/assets/icons/consultant-profile-icons/skills.svg" />
            </span>
          </div>
          <div class="tab" :class="{ active: tab_type == 'employment' }" @click="switchTab('employment')">
            <span class="name">Employment</span>
            <span class="icon">
              <img v-if="tab_type == 'employment'" src="@/assets/icons/consultant-profile-icons/employment-active.svg" />
              <img v-else src="@/assets/icons/consultant-profile-icons/employment.svg" />
            </span>
          </div>
          <div class="tab" style="justify-content: flex-end" :class="{ active: tab_type == 'qualification' }"
            @click="switchTab('qualification')">
            <span class="name">Qualification</span>
            <span class="icon">
              <img v-if="tab_type == 'qualification'"
                src="@/assets/icons/consultant-profile-icons/qualification-active.svg" />
              <img v-else src="@/assets/icons/consultant-profile-icons/qualification.svg" />
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="__body" :class="{ __onscoll_body: isScoll }" @scroll="onScoll">
      <div class="consultant-profile-container">
        <!-- Tab body section -->
        <div class="tab-body">
          <PublicInformation v-if="tab_type == 'public-information'"></PublicInformation>
          <Project v-if="tab_type == 'project'"></Project>
          <Skills v-if="tab_type == 'skills'"></Skills>
          <Employment v-if="tab_type == 'employment'"></Employment>
          <Qualification v-if="tab_type == 'qualification'"></Qualification>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Employment from "@/components/Consultant/Employment.vue";
import Project from "@/components/Consultant/Project.vue";
import PublicInformation from "@/components/Consultant/PublicInformation.vue";
import Qualification from "@/components/Consultant/Qualification.vue";
import Skills from "@/components/Consultant/Skills.vue";
import { mapGetters } from "vuex";
export default {
  name: "consultants",
  components: {
    Employment,
    Project,
    PublicInformation,
    Qualification,
    Skills,
  },
  props: {},
  data: () => {
    return {
      tab_type: "public-information",
      isScoll: false,
      profile_data: {
        projects: [],
        skills: [],
        employment: [],
        educations: [],
        trainings: [],
        certifications: [],
        tags: [],
        notifications: [],
        user: {},
        profile: {},
      },
    };
  },
  watch: {
    "$route.params.type"(val) {
      let vm = this;
      if (val) {
        vm.tab_type = val;
      } else {
        vm.tab_type = "public-information";
      }
    },
  },
  mounted() {
    let vm = this;
    vm.getProfileData();
    if (vm.$route.params.type) {
      vm.tab_type = vm.$route.params.type;
    } else {
      vm.tab_type = "public-information";
    }
  },
  computed: {},
  methods: {
    onScoll({ target }) {
      let vm = this;
      vm.isScoll = true;
    },
    getProfileData() {
      let vm = this;
      vm.$store.dispatch("GET_ME_PROFILE_DATA").then((response) => {
        let data = response.data;
        vm.profile_data = data;
      });
    },
    switchTab(type) {
      let vm = this;
      vm.$router.push({ path: "/profile/consultant/" + type });
    },
  },
};
</script>
<style lang="scss" scoped>
$assets: "~@/assets";

.consultant-profile-wrapper {
  background: #f7f7f7;
  min-height: 500px;
  width: 100%;
  padding-top: 55px;
  display: flex;
  align-items: center;
  flex-direction: column;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;

  @media (min-width: 300px) and (max-width: 630px) {
    bottom: 45px;
  }

  .__head {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 210px;
    width: 100%;

    .personal_data {
      width: 100%;
      height: 160px;
      background-size: cover;
      display: flex;
      justify-content: center;
      align-items: center;
      background-image: url($assets + "/images/backgrounds/wallpaper.svg");
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;

      .person-card {
        display: flex;
        align-items: center;
        flex-direction: column;

        img {
          width: 70px;
          height: 70px;
          border-radius: 100%;
          margin-bottom: 10px;
          object-fit: contain;
          transition: 400ms ease-in;
        }

        .info-text {
          display: flex;
          align-items: center;
          flex-direction: column;

          h2 {
            font-size: 20px;
            font-weight: bolder;
            margin-top: 0px;
            margin-bottom: 8px;
            color: #fff;
            text-transform: capitalize;
            transition: 400ms ease-in;
          }

          span {
            font-size: 15px;
            color: #fff;
            transition: 400ms ease-in;
          }
        }
      }
    }

    .tabs-widget {
      display: flex;
      align-items: center;
      justify-content: center;
      background: #efefef;
      width: 100%;
      border-bottom: 1px solid #efefef;

      .tabs-links {
        width: 800px;
        display: grid;
        grid-template-columns: 20% 20% 20% 20% 20%;

        @media (min-width: 300px) and (max-width: 630px) {
          width: 100%;
          padding-right: 10px;
          grid-template-columns: 19% 21% 22% 21% 21%;
        }

        .tab {
          text-align: center;
          cursor: pointer;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: center;

          @media (min-width: 300px) and (max-width: 630px) {
            font-size: 11px;
            justify-content: center !important;
          }

          .name {
            display: block;

            @media (min-width: 300px) and (max-width: 630px) {
              display: none;
            }
          }

          .icon {
            display: none;
            background: #dedede;
            height: 40px;
            width: 40px;
            justify-content: center;
            align-items: center;
            border-radius: 50%;

            @media (min-width: 300px) and (max-width: 630px) {
              display: flex;
            }

            img {
              width: 22.9px;
            }
          }
        }

        .tab.active {
          color: #04a5a5;
          font-weight: 800;

          .icon {
            background: #1890a9;
          }
        }

        .tab:hover {
          color: #04a5a5;
        }
      }
    }
  }

  .__onscoll_header {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 120px;
    width: 100%;
    transition: 200ms ease-in;

    .personal_data {
      width: 100%;
      height: 70px;
      background-size: cover;
      display: flex;
      justify-content: center;
      align-items: center;

      .person-card {
        display: flex;
        align-items: center;
        flex-direction: row;

        img {
          width: 40px;
          height: 40px;
          border-radius: 100%;
          object-fit: contain;
          margin-right: 15px;
          transition: 400ms ease-in;
        }

        .info-text {
          display: flex;
          align-items: flex-start;
          flex-direction: column;

          h2 {
            font-size: 16px;
            font-weight: bolder;
            margin-top: -10px;
            margin-bottom: 0px;
            color: #fff;
            transition: 400ms ease-in;
          }

          span {
            font-size: 13px;
            color: #fff;
            transition: 400ms ease-in;
          }
        }
      }
    }
  }

  .__body {
    width: 100%;
    height: calc(100% - 210px);
    overflow-x: hidden;
    overflow-y: auto;
    transition: 200ms ease-in-out;

    &.__onscoll_body {
      height: calc(100% - 120px);
      transition: 200ms ease-in-out;
    }

    padding-top: 15px;

    @media (min-width: 300px) and (max-width: 630px) {
      padding-top: 0px;
    }

    .consultant-profile-container {
      width: 100%;
      display: flex;
      align-items: center;
      flex-direction: column;

      .tab-body {
        width: 800px;

        @media (min-width: 300px) and (max-width: 630px) {
          width: 100%;
        }
      }
    }
  }
}
</style>